import {
  EssSection,
  EssTopic,
} from '@/domain/impact-ess/entities/question.entity';

export const essVenueDateQuizLayout: Record<
  EssTopic.PARITY_EQUALITY,
  { sections: Array<EssSection> }
> = {
  [EssTopic.PARITY_EQUALITY]: {
    sections: [
      EssSection.ARTISTIC_TEAM,
      EssSection.OCCASIONAL_OPERATIONAL_TEAM,
    ],
  },
};
